import { ModuleWithProviders, NgModule } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import { DfNgModule } from '@df/ng/df-ng.module';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NCore } from './df-core.interfaces';
import { ADirective } from './meta/router/a.directive';
import { DfUrlSerializer } from './meta/router/df-url-sanitizer';
import { StructuralDataService } from './meta/structural-data/structural-data.service';
import { StylesService } from './service/styles';

@NgModule({
    imports: [DfNgModule, ADirective],
    exports: [ADirective],
    providers: [{ provide: UrlSerializer, useClass: DfUrlSerializer }]
})
export class DfCoreModule {
    static forRoot(config?: DeepPartial<NCore.IModuleOptions>): ModuleWithProviders<DfCoreModule> {
        return {
            ngModule: DfCoreModule,
            providers: [
                {
                    provide: NCore.OPTIONS,
                    useFactory: () => {
                        return defaultsDeep(config, NCore.DEFAULT_OPTIONS);
                    }
                }
            ]
        };
    }

    constructor(stylesService: StylesService, structuralDataService: StructuralDataService) {
        stylesService.appInitialize();
        structuralDataService.appInitialize();
    }
}
